import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { calculateAge } from '../../commonClass/CommonValidation';

const FlightBookingDetailPopup = (props) => {
    const { flightData, show, setShow, activeTab } = props;

    const closeModal = () => {
        setShow(false)
    }

    const flightDateFormat = (date) => {
        const d = new Date(date);
        const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        let hours = d?.getHours();
        const minute = d?.getMinutes()?.toString()?.padStart(2, '0')
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12; // the hour '0' should be '12'
        return date ? `${day}-${month}-${year} ${hours?.toString()?.padStart(2, '0')}:${minute} ${ampm}, ${weekday}` : null;
    }

    const dateFormat = (date) => {
        const d = new Date(date);
        const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        return date ? `${day} ${month} ${year}, ${weekday}` : null;
    }

    const getCabinType = (type) => {
        switch (type) {
            case 1: return "All";
            case 2: return "Economy";
            case 3: return "PremiumEconomy";
            case 4: return "Business";
            case 5: return "PremiumBusiness";
            case 6: return "First";
            default: return '';
        }
    }
    const getGenderType = (type) => {
        switch (type) {
            case 1: return "Male";
            case 2: return "Female";
            default: return '';
        }
    }

    return (
        <>
            <Modal
                show={show}
                onHide={() => closeModal()}
                size="xl"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="sign-in-class flight_booking_detail"
                centered
            >
                <div className="modal-content border_outline">
                    <div className="modal-header py-2 border-0 row">
                        <div className="col-12 position-relative">
                            <div className='text-end'>
                                <button type="button" onClick={closeModal} className="btn booking_detail_close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-body px-0 pt-0">
                        {flightData?.response?.flightItinerary?.segments?.map((obj, mainindex) => (
                            <div className={`${mainindex > 0 ? 'mt-5' : ''}`}>
                                <div className="label_title">
                                    Booking Details
                                </div>

                                <div className="py-2 px-1">
                                    <table className='booking_detail_table w-100 text-center'>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className='fw-bold'> PNR No. </div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold text-muted'> {flightData?.response?.flightItinerary?.pnr} </div>
                                                </td>
                                                <td className='p-0' >
                                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold'> Booking ID </div>
                                                </td>
                                                <td>
                                                    <div className=''> {flightData?.BookingNo} </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <div className='fw-bold'> Ref ID </div>
                                                </td>
                                                <td>
                                                    <div className=''> {flightData?.response?.flightItinerary?.bookingId} </div>
                                                </td>
                                                <td className='p-0' >
                                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold'> Supplier </div>
                                                </td>
                                                <td>
                                                    <div className=''> TBO </div>
                                                </td>
                                            </tr>

                                            <tr>

                                                <td>
                                                    <div className='fw-bold'> Dep-Arr. </div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold text-muted'> {obj?.origin?.airport?.cityCode} - {obj?.destination?.airport?.cityCode} </div>
                                                </td>
                                                <td className='p-0' >
                                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold'> Booking Date </div>
                                                </td>
                                                <td>
                                                    <div className=''> {dateFormat(flightData?.BookingDate)} </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <div className='fw-bold'> Departure Date & Time </div>
                                                </td>
                                                <td>
                                                    <div className=''> {flightDateFormat(obj?.origin?.depTime)} </div>
                                                </td>
                                                <td className='p-0' >
                                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold'> Arrival Date & Time </div>
                                                </td>
                                                <td>
                                                    <div className=''> {flightDateFormat(obj?.destination?.arrTime)} </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <div className='fw-bold'> Airline name </div>
                                                </td>
                                                <td>
                                                    <div className=''> {obj?.airline?.airlineName} </div>
                                                </td>
                                                <td className='p-0' >
                                                    <div style={{ backgroundColor: '#0777A9' }} ></div>
                                                </td>
                                                <td>
                                                    <div className='fw-bold'> Booking Class </div>
                                                </td>
                                                <td>
                                                    <div className=''> {getCabinType(obj?.cabinClass)} </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <div className="label_title mx-1">
                                    Passenger Details
                                </div>

                                <div className="py-1 px-1">
                                    <div className='overflow-auto'>
                                        <table className='Passanger_detail_table w-100 text-center fs_14' style={{ wordBreak: 'break-word' }}>
                                            <thead>
                                                <tr>
                                                    <th>P. No</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Gender</th>
                                                    <th>Age</th>
                                                    <th>Contact No.</th>
                                                    <th>Email ID</th>
                                                    <th>Seat</th>
                                                    <th>Baggage</th>
                                                    <th>Meal</th>
                                                    <th>Special Services</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    flightData?.response?.flightItinerary?.passenger?.map((passenger, index) => {
                                                        return (
                                                            <tr key={`${passenger?.firstName}${index}`} >
                                                                <td style={{ minWidth: '50px' }}> <div> {index + 1} </div> </td>
                                                                <td style={{ minWidth: '100px' }}> <div> {passenger?.firstName} </div> </td>
                                                                <td style={{ minWidth: '100px' }}> <div> {passenger?.lastName} </div> </td>
                                                                <td style={{ minWidth: '80px' }}> <div> {getGenderType(passenger?.gender)} </div> </td>
                                                                <td style={{ minWidth: '50px' }}> <div> {calculateAge(passenger?.dateOfBirth)} </div> </td>
                                                                <td style={{ minWidth: '110px' }}> <div> {passenger?.contactNo} </div> </td>
                                                                <td style={{ minWidth: '150px' }}> <div> {passenger?.email} </div> </td>
                                                                <td style={{ minWidth: '50px' }}> <div> {passenger?.seatDynamic?.[mainindex]?.code || "N/A"} </div> </td>
                                                                <td style={{ minWidth: '70px' }}> <div> {`${passenger?.baggage?.[mainindex]?.weight ? `${passenger?.baggage?.[mainindex]?.weight} Kg` : "N/A"}`} </div> </td>
                                                                <td style={{ minWidth: '150px' }}> <div> {passenger?.mealDynamic?.[mainindex]?.airlineDescription || "N/A"} </div> </td>
                                                                <td style={{ minWidth: '50px' }}> <div> {passenger?.segmentAdditionalInfo?.[mainindex]?.specialService || "N/A"} </div> </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default FlightBookingDetailPopup
